// extracted by mini-css-extract-plugin
export default {"inputs-container":"PromptSettings_inputs-container__ZVCtK","text-area-wrapper":"PromptSettings_text-area-wrapper__xz2Hl","text-area":"PromptSettings_text-area__Cs6VN"};